import { QueryObserverOptions, useQuery } from 'react-query';

import getOutroi, { GetOutroiInput, GetOutroiOutput } from 'clients/api/queries/getOutroi';
import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';


type Options = QueryObserverOptions<
    GetOutroiOutput,
    Error,
    GetOutroiOutput,
    GetOutroiOutput,
    [FunctionKey.GET_OUTROI, string]
>;

const useGetOutroi = (
    { accountAddress }: Omit<GetOutroiInput, 'dlVaultContract'>,
    options?: Options,
) => {
  const dlVaultContract = useDlVaultContract();
    return useQuery(
        [FunctionKey.GET_OUTROI, accountAddress],
        () =>
            getOutroi({
                dlVaultContract,
                accountAddress,
            }),
        options,
    );
};

export default useGetOutroi;
